/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Agent_Access_Reason_Switched_OffInputs */



/**
* | output |
* | --- |
* | "your organization has switched {provider} off. Ask an organization admin." |
*
* @param {Agent_Access_Reason_Switched_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_reason_switched_off = /** @type {((inputs: Agent_Access_Reason_Switched_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Reason_Switched_OffInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihre Organisation hat ${i?.provider} ausgeschaltet. Wenden Sie sich an einen Admin Ihrer Organisation.`)
	return /** @type {LocalizedString} */ (`your organization has switched ${i?.provider} off. Ask an organization admin.`)
});